
import React, { Component } from "react";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import MobileVideoCards from "/components/Video/MobileVideoCards";
import ThereIsNoItem from '/components/thereIsNoItem';

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
  },
  brandVideoWrapper: {
    background: '#0A0A0A',
    padding: 14,
    [theme.breakpoints.only('xs')]: {
       padding: 0
    }
  }
});
class BrandVideos extends Component {
render() {
    const { classes, videos, videoNextBtn, videoItems } = this.props;
    return (
      <div>
        <NProgress />
        <div className={classes.brandVideoWrapper}>
            <Hidden only={['md', 'lg', 'xl']}>
                {
                    videos && videos.length === 0 ?
                    <ThereIsNoItem thereIsNoItem="There is no video." /> :  
                    <MobileVideoCards items={videos} newsItems={videoItems.length > 0 ? videoItems: null} />

                }
                {videoNextBtn}
            </Hidden>
            <Hidden smDown>
            <div className={classes.root}>
                <div className='layout'>
                    {
                         videos && videos.length === 0 ?
                        <ThereIsNoItem thereIsNoItem="There is no video." /> :  
                        <DesktopVideoCards items={videos} newsItems={videoItems.length > 0 ? videoItems: null} />
                    }
                    {videoNextBtn}
                </div>
            </div>
        </Hidden>
       </div>
      </div>
    );
  }
    }

export default withStyles(styles)(BrandVideos);
